import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { lang } from './lang-account-list-applies';
import { GradeManagerService } from '@app/_services/grade.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dialog-account-list-applies',
  templateUrl: './dialog-account-list-applies.component.html',
  styleUrls: ['./dialog-account-list-applies.component.scss']
})
export class DialogAccountListAppliesComponent implements OnInit {
  displayedColumns: string[] = ['stt','fullname', 'code', 'domain', 'phone', 'email'];
  listAccount:any;
  lang = lang;
  length:number;
  gradeName:string;
  constructor(
      dialogRef: MatDialogRef<any>,
      @Inject(MAT_DIALOG_DATA) public data,
      private gradeManagerService:GradeManagerService
  ) { }

  ngOnInit(): void {
    this.loadDataItems();
  }

  loadDataItems(keyword = ''){
    let dataFilter = {
      "keyword": keyword
    };
    this.gradeManagerService
      .filterTenantOfGrade(this.data.id,dataFilter)
      .subscribe((data:any) => {
        this.length = data.data.length;
        this.listAccount = new MatTableDataSource(data.data);
      },
      (error => {
      })
    );

    this.gradeManagerService
      .detailGrade(this.data.id)
      .subscribe((data:any) => {
        this.gradeName = data.data.fullname;
      },
      (error => {
      })
    );
  }

  searchListTenant(event,keyword){
    if(event.key == "Enter"){
      this.loadDataItems(keyword);
    }
  }

}
